import React from "react";
import { AnimatePresence, m } from "framer-motion";
import Header from "../../../components/Header";
import "./managedocument.css";
import { useTranslation } from "react-i18next";
import BreadCrumb from "../../../components/BreadCrumb";
import UploadDeleteFile from "../../../components/UploadDeleteFile";
import { useLocation } from "react-router-dom";

const ManageDocument = ({ language, changeLanguage }) => {
    const location = useLocation();
    const title = location.state?.title;
    const description = location.state?.description;
    const validFileExtension = location.state?.validFileExtension;
    const { t } = useTranslation();
    const fetchUrl = '/api/attachment?name=' + title;
    const uploadUrl = '/api/attachment/create';
    const deleteUrl = '/api/attachment/';
    const fileAccessUrl = 'https://cvparse.fra1.cdn.digitaloceanspaces.com/';
    const dataObj = {
        isUserSpecific: 0,
        isRoleSpecific: 1,
        isHead: 1,
    };
    const navigation = [
        { id: 0, name: t("dashboard"), url: "/recruitment/dashboard" },
        {
            id: 1,
            name: t(title),
            active: true,
        },
    ];

    return (
        <m.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.6 }}
        >
            <Header
                home={"/recruitment/dashboard"}
                logOut={"/recruitment"}
                language={language}
                changeLanguage={changeLanguage}
            />
            <m.div
                className="accounting-contacts"
                initial="hidden"
                animate="show"
            >
                <m.div className="title-text primary-color" >
                    {t(description)}
                </m.div>
                <m.div className="accounting-filter-nav-header-without" >
                    <BreadCrumb items={navigation} />
                </m.div>
                <AnimatePresence>

                </AnimatePresence>
                <m.div >
                    <UploadDeleteFile
                        title={title}
                        fetchUrl={fetchUrl}
                        uploadUrl={uploadUrl}
                        deleteUrl={deleteUrl}
                        fileAccessUrl={fileAccessUrl}
                        validFileExtension={validFileExtension}
                        dataObj={dataObj}
                    />
                </m.div>
            </m.div>
        </m.div >
    );
};

export default ManageDocument;
